// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 19:52:21

export default {
  "id": "dices-2048-3d",
  "slug": "dices-2048-3d",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/b97b603c983544a4a3c49066c5cd01d0-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/b97b603c983544a4a3c49066c5cd01d0/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Dices 2048 3D",
      "description": "Get ready for Dices 2048 3D! Dices 2048 3D features the classic 2048 gameplay. But it's not that easy in 3D! You can shoot the blocks not only horizontally, but also stack them on top of each other. And it gets even more challenging! Every now and then mighty stones appear blocking your way. Wait or use the powerful bombs to destroy them! Get ready and prepare your brains for some serious but awesome challenges!",
      "instructions": "Match 2 blocks of the same number to add them together and create a block with an even higher number.",
      "genres": [
        "Boardgames",
        "Merge"
      ],
      "tags": [
        "classic",
        "dice",
        "math"
      ]
    },
    "zh-CN": {
      "title": "掷2048 3D",
      "description": "准备好迎接Dices 2048 3D吧！Dices 2048 3D拥有经典的2048游戏玩法。但在3D世界里，这并不简单！你可以不仅水平射击方块，还可以将它们堆叠起来。而且挑战更加激烈！不时有强大的石块出现阻挡你的道路。等待或使用强力炸弹摧毁它们！做好准备，让大脑迎接一些严肃但极富挑战性的任务吧！",
      "instructions": "匹配两个相同数字的方块以将它们相加，并创建一个更高数字的方块。",
      "genres": [
        "桌面游戏",
        "合并"
      ],
      "tags": [
        "经典",
        "骰子",
        "数学"
      ]
    },
    "zh-TW": {
      "title": "骰子 2048 3D",
      "description": "準備好迎接Dices 2048 3D！Dices 2048 3D特色經典的2048遊戲玩法。但在3D世界中並不容易！你不仅能水平射擊塊體，還可以將其堆疊起來。而且挑戰還會更加激烈！不時會出現強大的石塊阻擋你的去路。等待或使用強大的炸彈將其摧毀！準備好並讓你的腦袋為一些嚴肅但精彩的挑戰做準備！",
      "instructions": "匹配兩塊相同數字的方塊來將它們相加，並創建一個更高數字的方塊。",
      "genres": [
        "桌面遊戲",
        "合併"
      ],
      "tags": [
        "經典",
        "骰子",
        "數學"
      ]
    },
    "zh-HK": {
      "title": "骰子 2048 3D",
      "description": "準備好玩3D骰子2048啦！3D骰子2048擁有經典的2048遊戲玩法。但在3D世界中，這並不容易！你可以不僅水平移動塊，還可以將它們堆疊起來。而且還會變得更挑戰！不時會出現強大的石頭阻擋你的去路。等待或使用強大的炸彈將它們消滅！準備好，並讓你的腦袋為一些嚴肅但精彩的挑戰做好準備！",
      "instructions": "匹配兩塊相同數字的方塊將它們相加，創造一塊數值更高的方塊。",
      "genres": [
        "棋盤遊戲",
        "合併"
      ],
      "tags": [
        "經典",
        "骰子",
        "數學"
      ]
    },
    "ja": {
      "title": "ダイス2048 3D",
      "description": "Dices 2048 3Dへようこそ！Dices 2048 3Dは、クラシックな2048のゲームプレイを搭載しています。しかし3Dでは簡単ではありません！ブロックを水平方向だけでなく、重ねて積むこともできます。さらに難しくなります！しばしば強力な石が道を塞ぎます。待つか、強力な爆弾を使って壊しましょう！準備を整え、脳を鍛え、真剣で素晴らしい挑戦に備えてください！",
      "instructions": "同じ数字のブロックを2つ合わせて合計し、より高い数字のブロックを作成します。",
      "genres": [
        "ボードゲーム",
        "統合"
      ],
      "tags": [
        "クラシック",
        "サイコロ",
        "数学"
      ]
    },
    "ko": {
      "title": "주사위 2048 3D",
      "description": "Dices 2048 3D를 준비하세요! Dices 2048 3D는 클래식 2048 게임 플레이를 특징으로 합니다. 하지만 3D에서는 그리 쉽지 않습니다! 블록을 수평으로만 아니라 쌓아 올릴 수 있습니다. 그리고 더욱 도전적이 됩니다! 때로는 강력한 돌들이 길을 막아섭니다. 기다리거나 강력한 지뢰를 사용하여 파괴하세요! 준비하고 뇌를 준비하세요, 진지하지만 놀라운 도전에 대비하세요!",
      "instructions": "같은 숫자의 블록 2개를 맞추어 더해 더 높은 숫자의 블록을 만들어주세요.",
      "genres": [
        "보드게임",
        "합성"
      ],
      "tags": [
        "클래식",
        "주사위",
        "수학"
      ]
    },
    "fr": {
      "title": "Dices 2048 3D",
      "description": "Préparez-vous à Dices 2048 3D ! Dices 2048 3D propose le gameplay classique de 2048. Mais ce n'est pas aussi facile en 3D ! Vous pouvez tirer sur les blocs non seulement horizontalement, mais aussi les empiler les uns sur les autres. Et ça devient encore plus difficile ! De temps en temps, des pierres puissantes apparaissent et bloquent votre chemin. Attendez ou utilisez les bombes puissantes pour les détruire ! Préparez-vous et préparez vos neurones pour des défis sérieux mais incroyables !",
      "instructions": "Associationnez deux blocs du même nombre pour les additionner et créer un bloc avec un nombre encore plus élevé.",
      "genres": [
        "Jeux de plateau",
        "Fusion"
      ],
      "tags": [
        "classique",
        "dés",
        "mathématiques"
      ]
    }
  }
};
